import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html'
})
export class AccessDeniedComponent implements OnInit {

  errorCode : string;
  errorTitle : string;
  errorMessage : string;

  constructor() { }

  ngOnInit(): void {
    this.errorCode = "403";
    this.errorTitle = "Access Denied"
    this.errorMessage = "Access to page is forbidden with current user permissions.\nPlease make sure you've logged in with the appropriate user account. \n\nContact your administrator otherwise."
  }

}
